// material
import { Container } from '@material-ui/core';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Edit from '../../components/currencies/edit';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
// components
import Page from '../../components/Page';
import { UserContext } from '../../contexts/UserContext';
// hooks
import useSettings from '../../hooks/useSettings';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';

// ----------------------------------------------------------------------

export default function EditCurrency() {
  const { themeStretch } = useSettings();

  // Get locationId from path
  const params: any = useParams();
  const [id, setId] = useState<string>(params?.id);
  const [{ user }]: any = React.useContext(UserContext);

  return (
    <Page title="Edit currency">
      <Container maxWidth={themeStretch ? false : 'xl'}>
        <HeaderBreadcrumbs
          heading="Edit currency"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Currencies', href: PATH_DASHBOARD.currencies },
            { name: 'Edit currency', href: PATH_DASHBOARD.currencies }
          ]}
        />
        <Edit id={id} setId={(id: string) => setId(id)} disabled={!user.canEdit} />
      </Container>
    </Page>
  );
}
